/**
 * 仅分类元数据，无产品大图依赖。供导航/筛选等轻量组件使用。
 */
export const productCategories = [
  { id: "uv", labelKey: "catUv", navLabelKey: "catUvNav" },
  { id: "dtf", labelKey: "catDtf", navLabelKey: "catDtfNav" },
  { id: "crystal", labelKey: "catCrystal", navLabelKey: "catCrystalNav" },
  { id: "dtg", labelKey: "catDtg", navLabelKey: "catDtgNav" },
  { id: "cylinder", labelKey: "catCylinder", navLabelKey: "catCylinderNav" },
];
